
export const Footer = () => {
  return (
    <div className="h-1/6 bg-stone-900">
      <div></div>
    </div>
  );
}
